<template>
  <div
    class="py-1 relative"
    role="none"
  >
    <div v-if="label" class="opacity-80 text-xs text-gray-700">
      <hr class="absolute inset-0 mt-3 mx-2">
      <span class="z-1 relative bg-white px-2">{{label}}</span>
    </div>
    <slot />
  </div>
</template>

<script>

export default {
  props: {
    label: {
      type: String,
      required: false
    }
  },
}
</script>
